const variables = {
  headerBgc: '#3e3e3e',
  headerBorderColor: '#818080',
  logoPrimary: '#D69723',
  logoSecondary: '#575C0E',
  linkColor: '#d3d3d3;',
  background: '#1a1a1a',
  serviceTitle: '#bcb7b7',
  advantageRectBg: '#515151',
};
export default variables;
